import { render } from "./Baths.vue?vue&type=template&id=d014331e"
import script from "./Baths.vue?vue&type=script&lang=js"
export * from "./Baths.vue?vue&type=script&lang=js"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__